export function formatSize(bytes?: number) {
  if (!bytes) return '0 b'

  const k = 1000
  const sizes = ['b', 'Kb', 'Mb', 'Gb'] as const

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  const unit = sizes[i] || ''

  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + unit
}
